{
  "name": "@ns/reporting-to",
  "version": "1.0.0",
  "description": "Please select from the below list who do you report to inside your organisation.",
  "inputs": {},
  "outcomes": {
    "complete": {}
  },
  "jobMetadata": [
    "SELECTED_MANAGERS",
    "DOES_NOT_REPORT_TO_ANYONE"
  ]
}
